var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlightTeaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 27H218V125H85V27Z",
    fill: "#4C6170",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174 27H218V76H174V27Z",
    fill: "#798894",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174 27H218V51H174V27Z",
    fill: "#F1F2F4",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 76H218V125H152V76Z",
    fill: "#D2D7DB",
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76H152V125H85V76Z",
    fill: "#798894",
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.453 92.052L177.931 91.0002L180.273 95.0088L203 133.916L204.51 136.5L206.32 134.116L213.116 125.168L230.088 137.613L231.674 138.776L232.863 137.21L238.593 129.666L239.823 128.046L238.183 126.844L221.265 114.439L228.021 105.545L229.888 103.086L226.881 102.387L182.453 92.052Z",
    fill: "white",
    stroke: "#4C6170",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#FFB60A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightTeaser);
export default __webpack_public_path__ + "static/media/highlight_teaser.03008a311260bce737345093409c9532.svg";
export { ForwardRef as ReactComponent };